/* CRO lot 6 — Linkify Pro, swatches de collection : le clic change la VIGNETTE sur place (photo, nom de couleur,
   prix, lien) au lieu d'ouvrir la fiche du coloris. Données : /products/{handle}.js (devise du marché actif),
   prix formaté par theme.Currency.formatMoney. Ne concerne que les swatches situés dans une vignette de grille ;
   les swatches de la fiche produit gardent le comportement de l'app. Retirer ce fichier = retour au clic → fiche. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var HANDLE_RE = new RegExp('/products/([^/?#]+)');

  function tileOf(el) {
    var n = el.parentElement;
    while (n && n !== document.body) {
      if (n.querySelector('.grid-product__image-mask') && n.querySelector('.grid-product__meta')) return n;
      n = n.parentElement;
    }
    return null;
  }
  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        var f = (theme.settings && theme.settings.moneyFormat) || theme.moneyFormat;
        return theme.Currency.formatMoney(cents, f);
      }
    } catch (e) {}
    return null;
  }
  function sized(url, w) {
    var base = url.split('?')[0];
    var m = url.match(/[?&](v=\d+)/);
    var v = m ? m[1] : null;
    return base + '?' + (v ? v + '&' : '') + 'width=' + w;
  }
  function setImage(img, url, alt) {
    if (!img || !url) return;
    var srcset = [360, 540, 720, 900, 1080].map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
    img.setAttribute('srcset', srcset);
    img.setAttribute('src', sized(url, 1080));
    if (alt) img.setAttribute('alt', alt);
    /* l'app Linkify restaure data-orig-src / data-orig-srcset au pointerleave : on y met la NOUVELLE image */
    img.setAttribute('data-orig-src', sized(url, 1080));
    img.setAttribute('data-orig-srcset', srcset);
  }
  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  /* Étiquette de vignette (New in, Best sellers, Sold out, Sale…) : rendue par Liquid via la Section Rendering API,
     section technique sections/plp-tile-data.liquid, même logique que product-grid-item.liquid. */
  var tagCache = {};
  function loadTag(handle) {
    if (tagCache[handle]) return tagCache[handle];
    tagCache[handle] = fetch(root + 'products/' + handle + '?sections=plp-tile-data', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j['plp-tile-data']) return null;
        var tmp = document.createElement('div');
        tmp.innerHTML = j['plp-tile-data'];
        var box = tmp.querySelector('[data-plp-tag]');
        return box ? box.innerHTML : null;
      })
      .catch(function () { return null; });
    return tagCache[handle];
  }
  function applyTag(tile, html) {
    if (html === null || html === undefined) return;
    /* l'étiquette est dans .grid-product__content, qui est un ANCÊTRE de la zone détectée par tileOf */
    var content = tile.closest('.grid-product__content') || tile.querySelector('.grid-product__content') || tile;
    /* retire l'étiquette actuelle : divs .grid-product__tag de premier niveau, avec leur éventuel lien parent */
    Array.prototype.slice.call(content.children).forEach(function (child) {
      var isTag = child.classList && child.classList.contains('grid-product__tag');
      var wrapsTag = child.tagName === 'A' && child.querySelector(':scope > .grid-product__tag');
      if (isTag || wrapsTag) content.removeChild(child);
    });
    if (html.trim()) content.insertAdjacentHTML('afterbegin', html);
  }
  function currentHandle(tile) {
    var link = tile.querySelector('a.grid-product__link');
    if (link) {
      var m = (link.getAttribute('href') || '').match(HANDLE_RE);
      if (m) return m[1];
    }
    return tile.getAttribute('data-plp-switched');
  }
  function apply(tile, sw, p) {
    if (!p) return;
    var imgs = tile.querySelectorAll('.grid-product__image-mask img');
    var pics = p.images && p.images.length ? p.images : [p.featured_image];
    if (imgs[0]) setImage(imgs[0], pics[0], p.title);
    /* Le thème affiche la 2e photo (imgs[1]) tant que la souris est sur la vignette. Au clic, la souris y est :
       on montre donc d'abord la photo principale du coloris, et la 2e photo ne reprend son rôle qu'après
       que la souris a quitté la vignette. */
    if (imgs[1]) {
      setImage(imgs[1], pics[0], p.title);
      if (pics[1]) {
        var onLeave = function () { setImage(imgs[1], pics[1], p.title); };
        tile.addEventListener('pointerleave', onLeave, { once: true });
      }
    }
    var parts = p.title.split(/\s+[-–]\s+/);
    var t2 = tile.querySelector('.grid-product__title2');
    if (t2 && parts[1]) t2.textContent = parts[1];
    var price = tile.querySelector('.grid-product__price');
    var m = money(p.price);
    if (price && m) {
      if (p.compare_at_price && p.compare_at_price > p.price) {
        var c = money(p.compare_at_price);
        price.innerHTML = '<span class="grid-product__price--original">' + c + '</span> ' + m;
      } else {
        price.textContent = m;
      }
    }
    var href = root + 'products/' + p.handle;
    tile.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('webyze-linkify-product-colors')) return; /* liens SEO des swatches : inchangés */
      a.setAttribute('href', href);
    });
    var host = sw.closest('webyze-linkify-product-colors');
    if (host) host.querySelectorAll('linkify-product-colors-swatch').forEach(function (s) { s.toggleAttribute('data-plp-current', s === sw); });
    tile.setAttribute('data-plp-switched', p.handle);
    switchQuickShop(tile, p);
  }
  /* Quick shop (« Achat rapide ») : le thème pré-rend une modale par vignette, liée au produit d'origine par son id
     (bouton .js-modal-open-quick-modal-{id}, modale #QuickShopModal-{id}, conteneur #QuickShopHolder-{handle}) et la
     remplit via theme.preloadProductModal(handle, id, bouton). Après un changement de coloris, on re-cible tout cela
     sur le nouveau produit, sinon le Quick shop ajoutait le coloris d'origine au panier. */
  function switchQuickShop(zone, p) {
    var tile = zone.closest('.grid-product') || zone;
    var btn = tile.querySelector('.quick-product__btn');
    var modal = tile.querySelector('[id^="QuickShopModal-"]');
    if (!btn || !modal || !window.theme || typeof theme.preloadProductModal !== 'function') return;
    if (modal.id === 'QuickShopModal-' + p.id) return;
    var holder = modal.querySelector('[id^="QuickShopHolder-"]');
    modal.id = 'QuickShopModal-' + p.id;
    modal.setAttribute('data-product-id', p.id);
    if (holder) { holder.id = 'QuickShopHolder-' + p.handle; holder.innerHTML = ''; }
    /* clone du bouton = on abandonne les écouteurs de l'ancienne modale */
    var fresh = btn.cloneNode(true);
    fresh.className = fresh.className.replace(/js-modal-open-quick-modal-\d+/, 'js-modal-open-quick-modal-' + p.id);
    if (fresh.className.indexOf('quick-product__btn--not-ready') === -1) fresh.className += ' quick-product__btn--not-ready';
    btn.parentNode.replaceChild(fresh, btn);
    tile.setAttribute('data-product-id', p.id);
    tile.setAttribute('data-product-handle', p.handle);
    try { theme.preloadProductModal(p.handle, p.id, fresh); } catch (e) {}
  }
  /* ---- Limite de swatches différente sur mobile ----
     L'app n'a qu'une limite globale (réglage « max swatches », ici 6). Sur mobile on n'affiche que MOBILE_MAX
     couleurs, suivies d'un « +N » cliquable qui déplie le reste. Sur desktop la limite de l'app s'applique telle quelle.
     Pour changer la valeur mobile : modifier MOBILE_MAX ci-dessous. */
  var MOBILE_MAX = 3;
  /* Desktop : l'app renvoie bien collectionMaxSwatches = 6 (réglage « Max swatches to show ») mais son script ne
     l'applique pas au rendu collection (10 pastilles observées). On applique donc la même valeur ici. */
  var DESKTOP_MAX = 6;
  var mqMobile = window.matchMedia('(max-width: 749px)');
  function currentMax() { return mqMobile.matches ? MOBILE_MAX : DESKTOP_MAX; }
  function visibleSwatches(host) {
    return Array.prototype.filter.call(host.querySelectorAll('linkify-product-colors-swatch'), function (s) {
      if (s.hasAttribute('data-plp-not-in-market')) return false; /* absente du marché du visiteur */
      return s.hasAttribute('data-plp-capped') || s.style.display !== 'none'; /* on ignore celles que l'app masque (rupture) */
    });
  }
  function capHost(host) {
    if (host.closest('.product-block')) return;
    var sws = visibleSwatches(host);
    var appMore = host.querySelector('linkify-product-colors-swatch-more:not([data-plp-more])');
    var ourMore = host.querySelector('[data-plp-more]');
    var max = currentMax();
    if (host.dataset.plpExpanded === '1' || sws.length <= max) {
      sws.forEach(function (s) { s.removeAttribute('data-plp-capped'); });
      if (ourMore) ourMore.remove();
      if (appMore) appMore.style.display = '';
      return;
    }
    var appExtra = appMore ? (parseInt(appMore.textContent.replace(/\D/g, ''), 10) || 0) : 0;
    var total = sws.length + appExtra;
    sws.forEach(function (s, i) { if (i >= max) s.setAttribute('data-plp-capped', ''); else s.removeAttribute('data-plp-capped'); });
    if (appMore) appMore.style.display = 'none';
    if (!ourMore) {
      ourMore = document.createElement('linkify-product-colors-swatch-more');
      ourMore.setAttribute('data-plp-more', '');
      ourMore.setAttribute('role', 'button');
      ourMore.setAttribute('tabindex', '0');
      ourMore.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        host.dataset.plpExpanded = '1';
        capHost(host);
      }, true);
      var list = host.querySelector('linkify-product-colors-swatches') || host;
      list.appendChild(ourMore);
    }
    var label = '+' + (total - max);
    if (ourMore.textContent !== label) ourMore.textContent = label; /* ne pas réécrire si identique : évite une mutation inutile */
  }
  function capAll() { document.querySelectorAll('webyze-linkify-product-colors').forEach(capHost); }
  var capScheduled = false;
  function scheduleCap() {
    if (capScheduled) return;
    capScheduled = true;
    /* setTimeout et non requestAnimationFrame : rAF est suspendu dans un onglet en arrière-plan */
    window.setTimeout(function () { capScheduled = false; capAll(); }, 0);
  }
  capAll();
  window.addEventListener('load', capAll);
  [1000, 3000, 6000].forEach(function (ms) { window.setTimeout(capAll, ms); }); /* filet de sécurité si l'app rend tard */
  /* Ne réagit qu'aux insertions de l'app Linkify (hôte ou swatches), jamais à nos propres éléments : pas de boucle. */
  new MutationObserver(function (muts) {
    var relevant = false;
    for (var i = 0; i < muts.length && !relevant; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute('data-plp-more')) continue;
        if (n.matches('webyze-linkify-product-colors, linkify-product-colors-swatches, linkify-product-colors-swatch') || n.querySelector('webyze-linkify-product-colors')) { relevant = true; break; }
      }
    }
    if (relevant) scheduleCap();
  }).observe(document.body, { childList: true, subtree: true });
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', capAll); else if (mqMobile.addListener) mqMobile.addListener(capAll);

  /* ---- Coloris absents du marché du visiteur (PDP et PLP) ----
     Linkify affiche toutes les couleurs publiées, sans tenir compte des marchés Shopify. Un coloris vendu aux US
     seulement (ex. Mini Dress Sasha Navy) apparaît donc depuis l'Indonésie ou l'Europe, et sa page répond en 404.
     Ici : requête Storefront @inContext(country) par lots de 40 handles ; les produits « null » sont masqués
     (attribut data-plp-not-in-market, CSS « CRO lot 11 »). Même logique que celle utilisée par le thème pour la dispo. */
  var marketChecked = {};
  var notInMarket = {};
  function markNotInMarket(handles) {
    handles.forEach(function (h) { notInMarket[h] = true; });
    document.querySelectorAll('linkify-product-colors-swatch[data-handle]').forEach(function (s) {
      if (notInMarket[s.getAttribute('data-handle')]) s.setAttribute('data-plp-not-in-market', '');
    });
    scheduleCap();
  }
  function checkMarket() {
    var country = (window.Shopify && Shopify.country) || null;
    if (!country || !/^[A-Z]{2}$/.test(country)) return;
    var handles = [];
    document.querySelectorAll('linkify-product-colors-swatch[data-handle]').forEach(function (s) {
      var h = s.getAttribute('data-handle');
      if (h && !marketChecked[h] && handles.indexOf(h) === -1) handles.push(h);
      if (h && notInMarket[h]) s.setAttribute('data-plp-not-in-market', '');
    });
    if (!handles.length) return;
    handles.forEach(function (h) { marketChecked[h] = true; });
    var chunks = [];
    for (var i = 0; i < handles.length; i += 40) chunks.push(handles.slice(i, i + 40));
    chunks.forEach(function (chunk) {
      var q = 'query @inContext(country: ' + country + ') {' + chunk.map(function (h, i) { return 'p' + i + ': product(handle: ' + JSON.stringify(h) + ') { handle }'; }).join(' ') + '}';
      fetch('/api/2024-10/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: q }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.data) { chunk.forEach(function (h) { delete marketChecked[h]; }); return; }
          var missing = [];
          chunk.forEach(function (h, i) { if (j.data['p' + i] === null) missing.push(h); });
          if (missing.length) markNotInMarket(missing);
        })
        .catch(function () { chunk.forEach(function (h) { delete marketChecked[h]; }); });
    });
  }

  /* ---- Anti-flash (PDP et PLP) ----
     L'app rend d'abord TOUTES les couleurs du groupe (ex. 64 pour la Sasha, dont 53 archivées), puis interroge Shopify
     et masque les indisponibles (style display:none). Entre les deux, l'utilisateur voit une rafale de pastilles.
     Ici : le bloc reste invisible (CSS « CRO lot 10 », opacity 0 tant que data-plp-ready est absent) jusqu'au premier
     masquage par l'app, ou au plus tard READY_FALLBACK ms après l'apparition des pastilles. */
  var READY_FALLBACK = 1200;
  function armReady(host) {
    if (host.dataset.plpArmed) return;
    var sws = host.querySelectorAll('linkify-product-colors-swatch');
    if (!sws.length) return;
    host.dataset.plpArmed = '1';
    var done = false;
    var finish = function () { if (done) return; done = true; host.setAttribute('data-plp-ready', ''); try { mo.disconnect(); } catch (e) {} };
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.tagName === 'LINKIFY-PRODUCT-COLORS-SWATCH' && t.style.display === 'none') { window.setTimeout(finish, 80); return; }
      }
    });
    mo.observe(host, { attributes: true, attributeFilter: ['style'], subtree: true });
    /* si l'app a déjà masqué avant qu'on observe */
    for (var k = 0; k < sws.length; k++) { if (sws[k].style.display === 'none') { window.setTimeout(finish, 80); break; } }
    window.setTimeout(finish, READY_FALLBACK);
  }
  function armAll() { document.querySelectorAll('webyze-linkify-product-colors').forEach(armReady); checkMarket(); }
  armAll();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('webyze-linkify-product-colors, linkify-product-colors-swatches, linkify-product-colors-swatch') || n.querySelector('webyze-linkify-product-colors'))) { window.setTimeout(armAll, 0); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  [500, 1500, 3000].forEach(function (ms) { window.setTimeout(armAll, ms); });

  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest && e.target.closest('linkify-product-colors-swatch[data-handle]');
    if (!sw || sw.closest('.product-block')) return;
    var tile = tileOf(sw);
    if (!tile) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    /* NB : l'app pose data-selected au SURVOL, inutilisable pour connaître le coloris courant.
       Le coloris courant = handle du lien de la vignette. */
    var handle = sw.getAttribute('data-handle');
    if (currentHandle(tile) === handle) return;
    load(handle).then(function (p) {
      if (!p) {
        /* produit absent du marché du visiteur (Ajax 404) : sa page répondrait en 404.
           On masque la pastille et on ne navigue pas. */
        markNotInMarket([handle]);
        return;
      }
      apply(tile, sw, p);
      loadTag(handle).then(function (html) { applyTag(tile, html); });
    });
  }, true);
})();
